import React, { useState, useEffect } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { Link } from 'react-router-dom';
import plaidService from '../../services/plaidService';

const PlaidStatus = () => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkStatus();
  }, []);

  const checkStatus = async () => {
    try {
      const connectionStatus = await plaidService.checkConnectionStatus();
      setStatus(connectionStatus);
    } catch (error) {
      console.error('Failed to check Plaid status:', error);
      setStatus({ connected: false, error: error.message });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <View style={styles.container}>
        <Text style={styles.loadingText}>Checking bank connection...</Text>
      </View>
    );
  }

  if (!status) return null;

  return (
    <View style={styles.container}>
      <View style={[
        styles.statusCard,
        status.connected ? styles.connectedCard : styles.disconnectedCard
      ]}>
        <View style={styles.statusHeader}>
          <Text style={styles.statusIcon}>
            {status.connected ? '🏦' : '⚠️'}
          </Text>
          <View style={styles.statusInfo}>
            <Text style={styles.statusTitle}>
              {status.connected ? 'Bank Connected' : 'No Bank Connected'}
            </Text>
            <Text style={styles.statusSubtitle}>
              {status.connected 
                ? `Real-time data from your accounts`
                : 'Connect your bank to see real data'
              }
            </Text>
          </View>
        </View>
        
        <Link to="/plaid-test" style={styles.linkStyle}>
          <TouchableOpacity style={[
            styles.actionButton,
            status.connected ? styles.manageButton : styles.connectButton
          ]}>
            <Text style={[
              styles.actionButtonText,
              status.connected ? styles.manageButtonText : styles.connectButtonText
            ]}>
              {status.connected ? 'Manage' : 'Connect Bank'}
            </Text>
          </TouchableOpacity>
        </Link>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 24,
  },
  loadingText: {
    fontSize: 14,
    color: '#6B7280',
    textAlign: 'center',
    padding: 16,
  },
  statusCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 3,
    elevation: 1,
    borderWidth: 1,
  },
  connectedCard: {
    borderColor: '#D1FAE5',
    backgroundColor: '#F0FDF4',
  },
  disconnectedCard: {
    borderColor: '#FED7AA',
    backgroundColor: '#FFFBEB',
  },
  statusHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  statusIcon: {
    fontSize: 24,
    marginRight: 12,
  },
  statusInfo: {
    flex: 1,
  },
  statusTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#111827',
    marginBottom: 2,
  },
  statusSubtitle: {
    fontSize: 14,
    color: '#6B7280',
  },
  linkStyle: {
    textDecorationLine: 'none',
  },
  actionButton: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 8,
    alignItems: 'center',
  },
  connectButton: {
    backgroundColor: '#2563EB',
  },
  manageButton: {
    backgroundColor: '#F3F4F6',
    borderWidth: 1,
    borderColor: '#D1D5DB',
  },
  actionButtonText: {
    fontSize: 14,
    fontWeight: '500',
  },
  connectButtonText: {
    color: '#FFFFFF',
  },
  manageButtonText: {
    color: '#374151',
  },
});

export default PlaidStatus; 